import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "sysSetting/";

// 系统配置信息 前端控制器
export const configView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "view", {
    data: _params,
    method: "GET",
  });
};
// 系统配置信息 前端控制器
export const configUnitInfo = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "unitInfo", {
    data: _params,
    method: "GET",
  });
};


// WEBPACK FOOTER //
// ./src/fetch/api/config.js